import {
  getEmployeeDetail,
} from "./hrAdminApi";


export const EMPLOYEE_DETAIL_STATUS =
  Object.freeze({
    LOADING: "loading",
    LOADED: "loaded",
    NOT_FOUND: "not_found",
    FORBIDDEN: "forbidden",
    INTEGRITY_ERROR: "integrity_error",
    GENERIC_ERROR: "generic_error",
  });


export function createEmployeeDetailLoadingState() {
  return {
    status:
      EMPLOYEE_DETAIL_STATUS.LOADING,
    data: null,
    error: null,
  };
}


function resolveErrorMessage(error) {
  const responseData =
    error?.response?.data;

  if (
    typeof responseData?.error === "string"
    && responseData.error.trim()
  ) {
    return responseData.error.trim();
  }

  if (
    typeof responseData?.message === "string"
    && responseData.message.trim()
  ) {
    return responseData.message.trim();
  }

  if (
    typeof error?.message === "string"
    && error.message.trim()
  ) {
    return error.message.trim();
  }

  return "Impossible de charger la fiche salarié.";
}


function createTerminalState(
  status,
  {
    data = null,
    error = null,
  } = {},
) {
  return {
    status,
    data,
    error,
  };
}


export async function loadEmployeeDetail({
  employeeUuid,
  companyUuid,
  asOf = "",
} = {}) {
  try {
    const data = await getEmployeeDetail({
      employeeUuid,
      companyUuid,
      asOf,
    });

    return createTerminalState(
      EMPLOYEE_DETAIL_STATUS.LOADED,
      {
        data,
        error: null,
      },
    );
  } catch (error) {
    const httpStatus =
      error?.response?.status;

    const message =
      resolveErrorMessage(error);

    if (httpStatus === 403) {
      return createTerminalState(
        EMPLOYEE_DETAIL_STATUS.FORBIDDEN,
        {
          error: message,
        },
      );
    }

    if (httpStatus === 404) {
      return createTerminalState(
        EMPLOYEE_DETAIL_STATUS.NOT_FOUND,
        {
          error: message,
        },
      );
    }

    if (httpStatus === 409) {
      return createTerminalState(
        EMPLOYEE_DETAIL_STATUS.INTEGRITY_ERROR,
        {
          error: message,
        },
      );
    }

    return createTerminalState(
      EMPLOYEE_DETAIL_STATUS.GENERIC_ERROR,
      {
        error: message,
      },
    );
  }
}


export default loadEmployeeDetail;
